export function notificationFromWebsocket(event: unknown): { title: string; body: string } | null {
  if (!event || typeof event !== 'object') {
    return null;
  }

  const record = event as {
    params?: { title?: string; body?: string };
    title?: string;
    body?: string;
  };

  const title = (record.params?.title || record.title || '').trim();
  const body = (record.params?.body || record.body || '').trim();

  if (!title && !body) {
    return null;
  }

  return {
    title: title || 'Новое уведомление',
    body: body || '',
  };
}
